import _ from 'underscore';

// Regular expressions used to determine if a URL starts with a valid domain name.
// Similar regex to Microsoft.Ads.Mca.Implementation.Ads.EO.ValidationHelper.ValidateWebsite
export const UrlRegex = /^https?:\/\/([a-z0-9-_]+\.)*[a-z0-9-_]+\.[a-z]{2,63}(?=$|\/)/i;
export const UrlRegexWithOptionalProtocol = /^(?:http(s)?:\/\/)?([a-z0-9-_]+\.)*[a-z0-9-_]+\.[a-z]{2,63}(\/[^\s]*\/?)*$/i;

/**
 * Validate a HTTP or HTTPS URL.
 * @param {String} url - Fully qualified URL, including the prefix. E.g. http://www.example.com/foo
 * @returns {Boolean} - True if the URL is valid.
 */
export function isValidUrl(url) {
  return _.isString(url) && UrlRegex.test(url);
}

/**
 * Extracts the protocol and domain from a URL, with no trailing slash.
 * @param {String} url - URL to extract from, e.g. 'https://abc-123.com/foo.html'
 * @returns {String} - Protocol and domain name, or null if url could not be parsed.
 */
export function getUrlProtocolAndDomain(url) {
  if (_.isString(url)) {
    const matches = url.match(UrlRegex);
    return _.first(matches);
  }

  return null;
}
